export default {
  min: 8,
  max: 20,
  message: 'Must be between 8 and 20 characters long.',
};
